import {useInfiniteQuery} from "react-query";
import {useParams} from "react-router-dom";
import api from "../services/api";

const fetchComments = (timing, page) => {
    return api.get(`/timings/${timing}/comments?page=${page}`).then(result => result.data);
}

const useFetchComments = () => {
    const { timing } = useParams();

    return useInfiniteQuery(
        [timing, 'comments'],
        ({pageParam = 1}) => fetchComments(timing, pageParam),
        {
            getNextPageParam: (lastGroup, allGroups) => lastGroup?.links?.next ? lastGroup?.meta?.current_page + 1 : false,
        }
    )
};

export default useFetchComments;
